/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'basket': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 31',
    data: '<path pid="0" d="M26.03 24c.21 0 .4-.06.58-.19.18-.12.3-.28.36-.47l4.78-14.06a1.17 1.17 0 00-.13-.9c-.1-.13-.22-.23-.37-.32a.88.88 0 00-.44-.12H9.6L7.97 2.4C7.66 1.32 7.2.65 6.59.39 6 .13 5.53 0 5.22 0H.94C.67 0 .44.1.25.28A.97.97 0 00-.03 1c0 .27.1.5.28.69.19.19.42.28.69.28h4.28c.08 0 .2.04.37.12.17.09.33.38.47.88l5.53 20.31a1 1 0 00.36.52c.18.13.37.2.58.2h13.5zm-.69-2H13.31L10.12 9.94h19.26L25.34 22zm-1.96 9a2.4 2.4 0 001.76-.73 2.4 2.4 0 00.73-1.77 2.4 2.4 0 00-.73-1.77 2.4 2.4 0 00-1.77-.73 2.4 2.4 0 00-1.76.73 2.4 2.4 0 00-.73 1.77c0 .69.24 1.28.73 1.77a2.4 2.4 0 001.77.73zm-9 0a2.4 2.4 0 001.76-.73 2.4 2.4 0 00.73-1.77 2.4 2.4 0 00-.73-1.77 2.4 2.4 0 00-1.77-.73 2.4 2.4 0 00-1.76.73 2.4 2.4 0 00-.73 1.77c0 .69.24 1.28.73 1.77a2.4 2.4 0 001.77.73z"/>'
  }
})
